// extracted by mini-css-extract-plugin
module.exports = {"Layout":"_2C2_cL2y9o3hHDuzV_hszk"};